import { App } from "app";
import "app/ui/palette/color.css";
import 'app/ui/scrollbar.css';
import "app/lib/i18n/i18n";
import "./index.css";
import '@diplodoc/transform/dist/css/yfm.css';
import '@diplodoc/transform/dist/js/yfm';
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { handleIframeMessage } from "./embed";
import { fixRoute } from "./routeFix";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    <App/>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
handleIframeMessage();
fixRoute();
